__turbopack_context__.v({
  "selected-facets": "selected-facets-component-module-scss-module__8hf4XG__selected-facets",
  "selected-facets__remove-all": "selected-facets-component-module-scss-module__8hf4XG__selected-facets__remove-all",
  "selected-facets__selected-facet": "selected-facets-component-module-scss-module__8hf4XG__selected-facets__selected-facet",
  "selected-facets__selected-facets-container": "selected-facets-component-module-scss-module__8hf4XG__selected-facets__selected-facets-container",
});
